import { Progress, Space, Typography } from '@sravni/react-design-system';
import type { ProgressProps } from '@sravni/react-design-system/lib/Progress';

type Props = {
  progressBarProps?: Partial<ProgressProps>;
  currentStep: number;
  totalSteps: number;
};

const { Text } = Typography;

export const FormProgress: FC<Props> = (props) => {
  const { progressBarProps, currentStep = 0, totalSteps = 0 } = props;
  const percent = totalSteps > 0 ? Math.round((currentStep / totalSteps) * 100) : 0;
  return (
    <Space
      size={12}
      direction="vertical"
    >
      <Space size={4}>
        <Text>
          Шаг {currentStep} из {totalSteps}
        </Text>
      </Space>
      <Progress
        {...progressBarProps}
        percent={percent}
      />
    </Space>
  );
};
